import React, {useEffect, useState} from 'react';
import Ranking from "../../components/layout/industryNtheme/Ranking";
import DetailBody from "../../components/layout/industryNtheme/DetailBody";
import {getRankingDataAPI} from "../../apis/news_service";

const MainDetailPage = () => {
    const path = window.location.pathname.split('/');
    const category = path[1] // industry or theme
    const [targetName, setTargetName] = useState('')
    const [themeCode, setThemeCode] = useState('')
    const [react, setReact] = useState( ['긍정', '상승'] )

    const [ranking, setRanking] = useState([]) // 랭킹 데이터


    const getData = () => {
        getRankingDataAPI(category, 5).then(res => {
            const target = category === 'industry'? res[0].FICS_sub : res[0].theme_name
            const theme = category === 'industry'? '' : res[0].theme_code
            setRanking(res)
            setTargetName(target)
            setThemeCode(theme)
        })
    }

    const nameClick = (target) => setTargetName(target)
    const themeCodeClick = (target) => setThemeCode(target)
    const reactClick = (target) => setReact(target)

    useEffect(getData, [])


    return (
        <div className='detail container'>
            <p className='inner_container category'>
                <span>전체기업 &nbsp;&nbsp;>&nbsp;&nbsp;  </span>
                <span>{category === 'industry'? '산업':'테마'}뉴스 &nbsp;&nbsp;>&nbsp;&nbsp; </span>
                <span>{category === 'industry'? '산업':'테마'}뉴스 상세</span>
            </p>
            <div className='inner_container flex_layout'>
                <Ranking ranking={ranking} nameClick={nameClick} themeCodeClick={themeCodeClick} reactClick={reactClick}/>
                <DetailBody ranking={ranking} targetName={targetName} themeCode={themeCode} react={react}/>
            </div>
        </div>

    );
};

export default MainDetailPage;